import {
  borderWidths,
  colors,
  gap,
  gutter,
  radius,
  spacing,
} from '@lamimed/pantheon';
import Image from 'next/image';
import styled, { css } from 'styled-components';

import { ColumnRowProps } from './containers/ColumnRow';

import { InfoBoxProps } from '.';

export const InfoBoxWrapper = styled.div<Required<InfoBoxProps>>`
  ${({
    backgroundColor,
    hasBorder,
    borderColor,
    marginBottom,
    marginTop,
    padding,
    minHeight,
  }) => css`
    width: 100%;
    background-color: ${colors[backgroundColor]};
    border-radius: ${radius.small};
    min-height: ${minHeight};

    margin-bottom: ${spacing[marginBottom]};
    margin-top: ${spacing[marginTop]};

    ${hasBorder &&
    css`
      padding: ${spacing[padding]};
      border: ${borderWidths.small} solid ${colors[borderColor]};
    `};
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const HeadWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: fit-content;
`;

export const CardWrapper = styled.div`
  display: flex;
`;

export const CardImage = styled(Image)`
  flex-shrink: 0;
  border-radius: ${radius.small};
  margin-right: ${spacing.small};
`;

export const CardDescription = styled.div`
  display: flex;
  flex-direction: column;
`;

export type ColumnRowWrapperProps = Pick<
  ColumnRowProps,
  | 'marginBottom'
  | 'marginTop'
  | 'reverse'
  | 'headVerticalAlignment'
  | 'justifyContent'
>;

export const ColumnRowWrapper = styled.div<ColumnRowWrapperProps>`
  ${({
    marginBottom,
    marginTop,
    reverse,
    headVerticalAlignment,
    justifyContent = 'space-between',
  }) => css`
    display: flex;
    width: 100%;

    justify-content: ${justifyContent};
    align-items: ${headVerticalAlignment};
    margin-bottom: ${marginBottom ? spacing[marginBottom] : spacing.none};
    margin-top: ${marginTop ? spacing[marginTop] : spacing.none};

    ${gap(gutter.small)}

    ${reverse &&
    css`
      flex-direction: row-reverse;
    `}
  `}
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${spacing.small};
`;
